
    import './styles.scoped.css';
    export default {
  "expandable-toggle-wrapper": "awsui_expandable-toggle-wrapper_c6tup_11h7v_9",
  "body-cell": "awsui_body-cell_c6tup_11h7v_16",
  "body-cell-content": "awsui_body-cell-content_c6tup_11h7v_24",
  "with-paddings": "awsui_with-paddings_c6tup_11h7v_24",
  "expandable-level-0": "awsui_expandable-level-0_c6tup_11h7v_30",
  "expandable-level-1": "awsui_expandable-level-1_c6tup_11h7v_37",
  "expandable-level-2": "awsui_expandable-level-2_c6tup_11h7v_44",
  "expandable-level-3": "awsui_expandable-level-3_c6tup_11h7v_51",
  "expandable-level-4": "awsui_expandable-level-4_c6tup_11h7v_58",
  "expandable-level-5": "awsui_expandable-level-5_c6tup_11h7v_65",
  "expandable-level-6": "awsui_expandable-level-6_c6tup_11h7v_72",
  "expandable-level-7": "awsui_expandable-level-7_c6tup_11h7v_79",
  "expandable-level-8": "awsui_expandable-level-8_c6tup_11h7v_86",
  "expandable-level-9": "awsui_expandable-level-9_c6tup_11h7v_93",
  "expandable-level-next": "awsui_expandable-level-next_c6tup_11h7v_100",
  "body-cell-align-top": "awsui_body-cell-align-top_c6tup_11h7v_118",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_11h7v_124",
  "body-cell-counter": "awsui_body-cell-counter_c6tup_11h7v_129",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_11h7v_227",
  "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_11h7v_317",
  "body-cell-expandable": "awsui_body-cell-expandable_c6tup_11h7v_317",
  "body-cell-editable": "awsui_body-cell-editable_c6tup_11h7v_317",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_11h7v_400",
  "sticky-cell-pad-inline-start": "awsui_sticky-cell-pad-inline-start_c6tup_11h7v_566",
  "has-selection": "awsui_has-selection_c6tup_11h7v_732",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_11h7v_901",
  "has-footer": "awsui_has-footer_c6tup_11h7v_904",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_11h7v_914",
  "sticky-cell": "awsui_sticky-cell_c6tup_11h7v_566",
  "table-variant-full-page": "awsui_table-variant-full-page_c6tup_11h7v_965",
  "sticky-cell-last-inline-end": "awsui_sticky-cell-last-inline-end_c6tup_11h7v_982",
  "sticky-cell-last-inline-start": "awsui_sticky-cell-last-inline-start_c6tup_11h7v_991",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_11h7v_1013",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_11h7v_1020",
  "body-cell-editor-wrapper": "awsui_body-cell-editor-wrapper_c6tup_11h7v_1046",
  "body-cell-success": "awsui_body-cell-success_c6tup_11h7v_1051",
  "body-cell-editor": "awsui_body-cell-editor_c6tup_11h7v_1046",
  "body-cell-editor-disabled": "awsui_body-cell-editor-disabled_c6tup_11h7v_1076",
  "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_11h7v_1085",
  "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_11h7v_1095",
  "body-cell-editor-row-editor": "awsui_body-cell-editor-row-editor_c6tup_11h7v_1098",
  "body-cell-editor-focusable": "awsui_body-cell-editor-focusable_c6tup_11h7v_1101",
  "body-cell-editor-icon": "awsui_body-cell-editor-icon_c6tup_11h7v_1125",
  "resizable-columns": "awsui_resizable-columns_c6tup_11h7v_1237",
  "expandable-cell-content": "awsui_expandable-cell-content_c6tup_11h7v_1240",
  "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_11h7v_1291",
  "body-cell-has-success": "awsui_body-cell-has-success_c6tup_11h7v_1294"
};
  